import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { OAuthModule, OAuthModuleConfig } from 'angular-oauth2-oidc';

// Altri import come i tuoi componenti e moduli...
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { SafePipe } from '../pipe/safe.pipe';
import { HeaderComponent } from './header/header.component';
import { FiltersDialogComponent } from './filters-dialog/filters-dialog.component';
import { FiltersDialogExpandComponent } from './filters-dialog/filters-dialog-expand/filters-dialog-expand.component';
import { LoaderComponent } from './loader/loader.component';
import { DescDialogComponent } from 'projects/menu/src/lib/desc-dialog/desc-dialog.component';
import { MenuModule } from 'projects/menu/src/public-api';
import { CommonModule } from '@angular/common';
import { PlatformsInfoPopupComponent } from './platforms-info-popup/platforms-info-popup.component';


// ✅ Configurazione statica richiesta da Angular 11 per forRoot()
export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: ['https://api.example.com'],
    sendAccessToken: true
  }
};

@NgModule({
  declarations: [
    AppComponent,
    PlatformsInfoPopupComponent,
    HeaderComponent,
    FiltersDialogComponent,
    FiltersDialogExpandComponent,
    LoaderComponent,
    SafePipe,
    DescDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    MenuModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    MatIconModule,
    MatSnackBarModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    OAuthModule.forRoot()
  ],
  exports: [SafePipe],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    SafePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
